import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=de64dc1c&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=de64dc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de64dc1c",
  null
  
)

export default component.exports